"use strict";

import $ from 'jquery';
import appInit from './src/script-home';

window.$=window.jQuery=$;

window.app=null;

$(function () {
    window.app=new appInit();
});